import { render, staticRenderFns } from "./PainelHeader.vue?vue&type=template&id=4603b78e&scoped=true"
import script from "./PainelHeader.vue?vue&type=script&lang=js"
export * from "./PainelHeader.vue?vue&type=script&lang=js"
import style0 from "./PainelHeader.vue?vue&type=style&index=0&id=4603b78e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603b78e",
  null
  
)

export default component.exports